import { observer } from 'mobx-react';
import { useMemo } from 'react';
import AsModal from '../../Modal/AsModal';
import { CloseAction, OpenableState } from '../../Modal/UseOpenable';
import { ImportedParticipantsResource } from '../Store/Types';
import AddParticipantsToGroupFormState from './AddParticipantsToGroupFormState';
import { AddParticipantsToGroupFormStore } from './AddParticipantsToGroupFormState/AddParticipantsToGroupForm/Store';
import AddParticipantsToGroupFormReactions from './AddParticipantsToGroupFormState/AddParticipantsToGroupForm/Store/Reactions';

interface Props {
  successfulParticipantsResource: ImportedParticipantsResource;
  close: CloseAction;
  modalState: OpenableState;
}

function AddParticipantsToGroupModal({ successfulParticipantsResource, close, modalState }: Props) {
  const resource = successfulParticipantsResource;
  const addParticipantsToGroupFormStore = useMemo(
    () => new AddParticipantsToGroupFormStore(resource.payload.successfulParticipants, resource),
    [resource],
  );

  return (
    <AsModal close={close} state={modalState} title="">
      <AddParticipantsToGroupFormState
        successfulParticipantsResource={resource}
        addParticipantsToGroupFormStore={addParticipantsToGroupFormStore}
      />
      <AddParticipantsToGroupFormReactions
        store={addParticipantsToGroupFormStore}
        fireImmediately
      />
    </AsModal>
  );
}

export default observer(AddParticipantsToGroupModal);
